"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "To begin with, can you write down an unhelpful thought that has been bothering you lately?",
  type: "textarea",
  meta: {
    answerLabel: "My unhelpful thought is..",
    summaryTitle: "Your original unhelpful thought was…"
  },
  options: ["My unhelpful thought is"],
  batteryId: "RETRAINING_THINKING_BELIEFS"
}, {
  prompt: "What does this mean about you if this (your unhelpful thought above) was true?",
  type: "textAreaWithMoreEnd",
  meta: {
    answerLabel: "What is your responsibility thought?",
    summaryTitle: "The beliefs underlying this thought were"
  },
  moreInfoLabel: "I’m confused. Can I get some more instructions?",
  endLabel: "I think I’ve already found my belief. Let’s stop here",
  moreInfo: ["Try to think about what your thoughts or your reaction to a situation mean about you as a person.", "Look for negative core beliefs that are probably the ones you feel ashamed to admit.", "What do you think of yourself deep down if you act or think in a negative way?"],
  batteryId: "RETRAINING_THINKING_BELIEFS"
}, {
  prompt: "And what does this mean about you if this thought above was true?",
  type: "textAreaWithEnd",
  meta: {
    answerLabel: "What does it mean?",
    summaryTitle: "The beliefs underlying this thought were:"
  },
  endLabel: "I think I’ve already found my belief. Let’s stop here",
  batteryId: "RETRAINING_THINKING_BELIEFS"
}, {
  prompt: "And what does this mean about you if this thought above was true?",
  type: "textAreaWithEnd",
  meta: {
    answerLabel: "What does it mean?",
    summaryTitle: "The beliefs underlying this thought were:"
  },
  endLabel: "I think I’ve already found my belief. Let’s stop here",
  batteryId: "RETRAINING_THINKING_BELIEFS"
}, {
  prompt: "And what does this mean about you if this thought above was true?",
  type: "textAreaWithEnd",
  meta: {
    answerLabel: "What does it mean?",
    summaryTitle: "The beliefs underlying this thought were:"
  },
  endLabel: "I think I’ve already found my belief. Let’s stop here",
  batteryId: "RETRAINING_THINKING_BELIEFS"
}, {
  prompt: "And what does this mean about you if this thought above was true?",
  type: "textAreaWithEnd",
  meta: {
    answerLabel: "What does it mean?",
    summaryTitle: "The beliefs underlying this thought were:"
  },
  endLabel: "I think I’ve already found my belief. Let’s stop here",
  batteryId: "RETRAINING_THINKING_BELIEFS"
}, {
  prompt: "And what does this mean about you if this thought above was true?",
  type: "textAreaWithEnd",
  meta: {
    answerLabel: "What does it mean?",
    summaryTitle: "The beliefs underlying this thought were:"
  },
  endLabel: "I think I’ve already found my belief. Let’s stop here",
  batteryId: "RETRAINING_THINKING_BELIEFS"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (index <= answers[question.batteryId].length - 1) {
      if (!question.hideFromSummary && answers[question.batteryId][index]) {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;